import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=a2999e68&scoped=true&lang=pug&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=a2999e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2999e68",
  null
  
)

export default component.exports